'use client';
import { Button } from '@mui/material';

interface TabButtonProps {
  children?: React.ReactNode;
  label?: string;
  isActive?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

export const TabButton = ({ children, label, isActive = false, onClick }: TabButtonProps) => {
  if (children) {
    return (
      <Button
        variant="text"
        onClick={onClick}
        disableRipple
        sx={{
          minWidth: 'auto',
          p: 0,
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.875rem',
          color: isActive ? 'text.primary' : 'text.secondary',
          position: 'relative',
          borderRadius: 2,
          '&:hover': {
            bgcolor: 'transparent',
            color: 'text.primary',
          },
          ...(isActive && {
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -4,
              left: 0,
              right: 0,
              height: '2px',
              bgcolor: 'text.primary',
            },
          }),
        }}
      >
        {children}
      </Button>
    );
  }

  return (
    <Button
      variant={isActive ? 'contained' : 'outlined'}
      onClick={onClick}
      sx={{
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        px: 2,
        py: 0.75,
        bgcolor: isActive ? 'primary.main' : 'background.paper',
        color: isActive ? 'common.white' : 'text.primary',
        borderColor: isActive ? 'primary.main' : 'divider',
        '&:hover': {
          bgcolor: isActive ? 'primary.dark' : 'action.hover',
          borderColor: isActive ? 'primary.dark' : 'divider',
        },
      }}
    >
      {label}
    </Button>
  );
};
